import PublicIcon from '@mui/icons-material/Public';
import ZoneList from './ZoneList';

export default {
  icon: PublicIcon,
  list: ZoneList,
};
